import { matchRouteName, pageState } from '@helpers/page-state';
import axios from 'axios';

const state = (matchRouteName('home')
    || matchRouteName('ads.search-keyword')
    || matchRouteName('ads.search-keyword-map')
    || matchRouteName('company-search-page')
    || matchRouteName('land-locator')
) && {
    area: pageState.area,
};

const actions = {
    async fetchArea({ commit }, params) {
        const { searchString, searchType } = params;
        if (!searchString) {
            await commit('setArea', null);
            return null;
        }
        return axios.get(`/api/area/place/${searchType}/${searchString}`)
            .then((res) => res.data)
            .then(async ({ data }) => {
                await commit('setArea', data);
            });
    },
};

const mutations = {
    setArea(state, payload) {
        state.area = payload;
    },
};

const getters = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
